import { memo, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { LoaderSize } from './types';
import { LoadersText } from './constants';
import { SVG } from 'components';
import { Wrapper, LoaderText, TextWrapper } from './lines-loader.styled';
import { Icons } from 'assets';

interface IProps {
  loaderType?: 'tenant' | 'employee' | 'other' | 'worker';
  size?: LoaderSize;
}

const fadeVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.3 } },
  exit: { opacity: 0, transition: { duration: 0.2 } },
};

export const LinesLoader = memo(({ loaderType, size = 'medium' }: IProps) => {
  const [textIndex, setTextIndex] = useState<number>(0);
  const [texts, setTexts] = useState<string[]>([]);

  useEffect(() => {
    if (!loaderType) {
      return;
    }

    setTexts(LoadersText[loaderType === 'employee' ? 'worker' : loaderType]);
    setTextIndex(0);

    if (!texts.length) {
      return;
    }

    const interval = setInterval(() => {
      setTextIndex((prev) => (prev + 1) % texts.length);
    }, 1500);

    return () => clearInterval(interval);
  }, [texts]);

  const currentText = texts[textIndex];

  return (
    <Wrapper>
      <SVG
        src={Icons.Loader}
        props={{
          cursor: 'inherit',
          size: size === 'small' ? '16px' : size === 'medium' ? '24px' : '32px',
        }}
      />

      <TextWrapper>
        <AnimatePresence>
          {!!currentText && (
            <motion.div
              key={textIndex}
              variants={fadeVariants}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <LoaderText
                variant="body-14"
                color="gray.500"
                whiteSpace="nowrap"
              >
                {currentText}
              </LoaderText>
            </motion.div>
          )}
        </AnimatePresence>
      </TextWrapper>
    </Wrapper>
  );
});
